import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, Pagination, TableHead, TableRow, Dialog } from '@mui/material'
import { useSelector } from 'react-redux';
import ConfigurationsHook from '../../hooks/ConfigurationsHook';
import { useAuthContext } from '../../hooks/agencyAuthHook'
import toast from 'react-hot-toast'
import { useParams } from "react-router-dom";
import Chip from '@mui/material/Chip';
import AddIcon from '@mui/icons-material/Add';
export default function Configurations() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const configurations = useSelector((state) => state.configurations.configurations);
  const { getConfigurations } = ConfigurationsHook();
  useEffect(() => {
    getConfigurations()
    document.title = "Configurations"
  }, [])


  let { type } = useParams()
  const { agency } = useAuthContext()
  const [title, setTitle] = useState("");
  const [code, setCode] = useState("");
  const [location, setlocation] = useState("");
  const [distance, setdistance] = useState();
  const [hotel_type, sethotel_type] = useState("");
  const [shirka_logo, setshirka_logo] = useState("");

  const [images, setimages] = useState([]);

  const [isActive, setActive] = useState(true);

  const handleToggle = () => {
    setActive(!isActive);
  };


   // Handle image selection
   const handleShirkaImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds the 5MB limit. Please select a smaller file.');
      } else {
        TransformShirkaFile(file);
      }
    }
  };
   // Transform file to base64
   const TransformShirkaFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setshirka_logo(reader.result,
      );
    };
  };


  const [facilities, setfacilities] = useState([]);
  const handleToggleFacilities = (chip) => {
    if (facilities.includes(chip)) {
      setfacilities(facilities.filter((c) => c !== chip)); // Remove if already selected
    } else {
      setfacilities([...facilities, chip]); // Add if not selected
    }
  };
  
  let numPictures = 5
  const [selectedImageNames, setSelectedImageNames] = useState([]);

  const handleImage = (e) => {
    // Check if files are selected
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      // Check if the selected image already exists in the list
      if (selectedImageNames.includes(file.name)) {
        alert('You have already selected this image.');
      } else {
        if (images.length === parseInt(numPictures)) {
          alert(`You can upload only ${numPictures} pictures.`);
        } else {
          if (file) {
            if (file.size > 5 * 1024 * 1024) {
              alert('File size exceeds the 5MB limit. Please select a smaller file.');
            } else {
              TransformFile(file);
              // Add the filename to the list of selected image names
              setSelectedImageNames([...selectedImageNames, file.name]);
            }
          } else {
            alert('No file selected.');
          }
        }
      }
    } else {
      alert('No file selected.');
    }
  }


  const TransformFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setimages([...images, reader.result]);
    };
  }


  const handleRemoveImage = (index) => {
    // Remove the image from the images array
    const updatedImages = images.filter((image, i) => i !== index);
    setimages(updatedImages);

    // Remove the image name from the selectedImageNames array
    const updatedImageNames = selectedImageNames.filter((name, i) => i !== index);
    setSelectedImageNames(updatedImageNames);
  }

  // Config Edition
  const [editedConfig, setEditedConfig] = useState(null)
  
  const [openNew, setOpenNew] = React.useState(false);
  const handleClickOpenNew = () => {
    setOpenNew(true);
  };

  const handleCloseNew = () => {
    setOpenNew(false);
    setTitle('')
    setCode('')
    setlocation('')
    setdistance('')
    sethotel_type('')
    setimages([])
    setfacilities([])
    setEditedConfig('')
    setshirka_logo('')
    setActive(false)
  }

  const handleEditView = (data) => {
    setEditedConfig(data);
    setOpenNew(true);
    setTitle(data.title || "");
    setCode(data.code || '')
    setlocation(data.location || '')
    setdistance(data.distance || '')
    sethotel_type(data.hotel_type || '')
    setimages(data.images || [])
    setfacilities(data.facilities ||[])
    setshirka_logo(data.shirka_logo)
    setActive(data.isActive || false)

  }

  // API Call to add a new Configu
  const [loading1, setLoading1] = useState(false)
  const addNewConfigu = async (e) => {
    e.preventDefault()
    setLoading1(true)
    try {
      const response = await fetch(`${apiUrl}/api/agencies/configurations/add`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${agency.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { type, title, code,location,distance,hotel_type,images,shirka_logo,facilities, isActive } })
      })
      const json = await response.json()
      if (response.ok) {
        toast.success(json.message)
        getConfigurations()

        setLoading1(null)
        handleCloseNew()
      }
      if (!response.ok) {
        toast.error(json.message)
        setLoading1(null)
      }
    } catch (error) {
      setLoading1(null)
    }
  }

  const updateConfigu = async (e) => {
    e.preventDefault()
    setLoading1(true)
    try {
      const response = await fetch(`${apiUrl}/api/agencies/configurations/update`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${agency.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { _id: editedConfig._id, type, title, code,location,distance,hotel_type,images,shirka_logo,facilities,isActive } })
      })

      const json = await response.json()
      if (response.ok) {
        toast.success(json.message)
        getConfigurations()
        setLoading1(null)
        handleCloseNew()
      }
      if (!response.ok) {
        toast.error(json.message)
        setLoading1(null)
      }
    } catch (error) {
      setLoading1(null)
    }
  }

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;


  // Handle search input change
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const filteredConfigurations = configurations && configurations
    .filter(configu => {
      const matchesSearch = (
        configu?.type?.trim().toLowerCase() === type.trim().toLowerCase()
      );

      return matchesSearch
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


  // Paginate the filtered categories
  const paginatedConfigurations = filteredConfigurations.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  //deleting the configuration

  const [delLoading, setDelLoading] = useState(false)
  const deleteConfigu = async (configId) => {
    if (window.confirm('Are you sure you want to delete?')) {
      setDelLoading(true)
      try {
        const response = await fetch(`${apiUrl}/api/agencies/configurations/delete`, {
          method: "DELETE",
          headers: {
            'Authorization': `Bearer ${agency.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ configId })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          getConfigurations()
          setDelLoading(null)
        }
        if (!response.ok) {
          toast.error(json.message)
          setDelLoading(null)
        }
      } catch (error) {
        setDelLoading(null)
      }
    }
  }


  //handling images view 
  const [viewImages,setViewImages]=useState([])
  const [isImagesModal,setIsViewImages]=useState(false)

  const handleViewImages=(data)=>{
    setIsViewImages(true)
    setViewImages(data)

  }
  const handleCancelViewImages=()=>{
    setIsViewImages(false)
    setViewImages([])
  }

  const collapsed = useSelector((state) => state.collapsed.collapsed);
  return (
    <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
      <div className="container-fluid bg-none my-0 mt-4">
        <div className="row px-2 mt-5 pt-4">
          <div className="col-md-12 data_table p-2 pb-3">
            <div className="d-flex justify-content-between searchbar pb-2 pt-2 px-md-3 my-auto">
              <div className="d-flex left my-auto mb-2 mb-md-0 ps-3 ps-md-0">
                <h6>{type?.trim()?.toLowerCase()==='transportation services for'?'Transportation Trips':type?.trim()?.toLowerCase()==='transports'?'Transportation Types':type}</h6>
              </div>
              <div className="d-flex right my-auto">
                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 search_icon_svg">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
                <input type="text"  value={search} onChange={handleSearchChange} placeholder='Seacrh..' /> */}
                <button className='add_btn btn ms-1' onClick={() => handleClickOpenNew()}>Add {type?.trim()?.toLowerCase()==='transportation services for'?'Transportation Trip':type?.trim()?.toLowerCase()==='transports'?'Transportation Type':type.endsWith('ss')?type:type.endsWith('ies')?type.slice(0,-3)+'y':type.endsWith('s')?type.slice(0,-1):type}</button>
              </div>
            </div>
            <TableContainer>
              <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table" className='text-center'>
                <TableHead >
                  <TableRow >
                    <TableCell className='th text-center' >SN</TableCell>
                   
                    {type==='airlines' &&
                    <TableCell className='th text-center'>ID/Code</TableCell>
                    }
                    

                    <TableCell className='th text-center'>{type?.trim()?.toLowerCase()==='transportation services for'?'Transportation Trips':type?.trim()?.toLowerCase()==='transports'?'Transportation Types':type}</TableCell>
                    {type==='shirka' && 
                    <TableCell className='th text-center'>Logo</TableCell>
                    }
                    {type&&type==='hotels'&&
                    <>
                    <TableCell className='th text-center'>Location</TableCell>
                    <TableCell className='th text-center'>Distance</TableCell>
                    <TableCell className='th text-center'>Hotel Type</TableCell>
                    <TableCell className='th text-center'>Images</TableCell>
                    </>
                    }
                    <TableCell className='th text-center'>Status</TableCell>
                    <TableCell className='th text-center'>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {paginatedConfigurations && paginatedConfigurations.length > 0 ? paginatedConfigurations
                    .map((data, index) => (
                      <>
                        <TableRow className='table_row'>
                          <TableCell className='text-center td'>{index + 1}</TableCell>
                          {type==='airlines' &&
                           <TableCell className='text-center td code_td'>{data.code}</TableCell>
                          }
                         
                          <TableCell className={`text-center td ${type.trim().toLowerCase().includes('currency')?'uppercase_td':''}`}>{data.title}</TableCell>
                          {type==='shirka' &&
                          <TableCell className='text-center td py-1'> <img src={data.shirka_logo} alt="" /> </TableCell>
                          }
                          {type&&type==='hotels'&&
                          <>
                          <TableCell className='text-center td'>{data.location}</TableCell>
                          <TableCell className='text-center td'>{data.distance}</TableCell>
                          <TableCell className='text-center td'>{data.hotel_type}</TableCell>
                          <TableCell className='text-center td'>
                            <button onClick={()=>handleViewImages(data.images)} disabled={data.images.length<1}><svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.1959 9.49152C18.4527 9.85159 18.5811 10.0316 18.5811 10.2981C18.5811 10.5646 18.4527 10.7447 18.1959 11.1047C17.0422 12.7226 14.0956 16.2103 10.1352 16.2103C6.17466 16.2103 3.22814 12.7226 2.07438 11.1047C1.8176 10.7447 1.68921 10.5646 1.68921 10.2981C1.68921 10.0316 1.8176 9.85159 2.07438 9.49152C3.22814 7.87366 6.17466 4.38596 10.1352 4.38596C14.0956 4.38596 17.0422 7.87366 18.1959 9.49152Z" stroke="#6D76A1" stroke-width="1.52027"/>
                            <path d="M12.6689 10.2981C12.6689 8.89872 11.5345 7.76431 10.1351 7.76431C8.73573 7.76431 7.60132 8.89872 7.60132 10.2981C7.60132 11.6975 8.73573 12.8319 10.1351 12.8319C11.5345 12.8319 12.6689 11.6975 12.6689 10.2981Z" stroke="#6D76A1" stroke-width="1.52027"/>
                            </svg>
                            </button>
                            </TableCell>
                          </>
                          }
                          <TableCell className='text-center td'>{data.isActive ? <span className='active_status'><i className="fa-solid fa-circle-notch"></i> Active</span> : <span className='inactive_status'><i className="fa-solid fa-circle-notch"></i> Inactive</span>}</TableCell>
                          <TableCell className='td text-center'>
                            <div className="btn-group" role="group" aria-label="Basic example">
                              <button onClick={() => handleEditView(data)}>
                                <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.0403 1.85156H8.35113C4.12815 1.85156 2.43896 3.54075 2.43896 7.76373V12.8313C2.43896 17.0543 4.12815 18.7435 8.35113 18.7435H13.4187C17.6417 18.7435 19.3309 17.0543 19.3309 12.8313V11.1421" stroke="#08A5DC" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M14.2974 2.71332L7.642 9.36873C7.38862 9.62211 7.13524 10.1204 7.08457 10.4836L6.72139 13.0258C6.58626 13.9464 7.2366 14.5883 8.1572 14.4616L10.6994 14.0985C11.0542 14.0478 11.5525 13.7944 11.8143 13.541L18.4697 6.88562C19.6184 5.73697 20.1589 4.40251 18.4697 2.71332C16.7805 1.02413 15.4461 1.56467 14.2974 2.71332Z" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M13.3428 3.66797C13.9087 5.68655 15.488 7.26594 17.5151 7.84027" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </button>
                              <button onClick={() => deleteConfigu(data._id)}>
                                <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16.6523 4.80811L16.1289 13.2752C15.9952 15.4386 15.9283 16.5202 15.3861 17.2979C15.118 17.6823 14.7728 18.0068 14.3725 18.2507C13.5629 18.7439 12.4792 18.7439 10.3117 18.7439C8.14144 18.7439 7.05629 18.7439 6.24611 18.2498C5.84556 18.0055 5.50029 17.6804 5.23229 17.2953C4.69022 16.5164 4.62483 15.4332 4.49405 13.2668L3.9834 4.80811" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                  <path d="M2.71631 4.80764H17.919M13.7431 4.80764L13.1665 3.61822C12.7835 2.82813 12.592 2.43308 12.2617 2.1867C12.1884 2.13205 12.1108 2.08344 12.0297 2.04134C11.6639 1.85156 11.2249 1.85156 10.3468 1.85156C9.44674 1.85156 8.9967 1.85156 8.62482 2.0493C8.54241 2.09312 8.46376 2.1437 8.3897 2.20052C8.05553 2.45688 7.86887 2.86639 7.49554 3.6854L6.98398 4.80764" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                  <path d="M8.20605 14.0981L8.20605 9.03058" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                  <path d="M12.4292 14.0983L12.4292 9.03076" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                </svg>
                              </button>
                            </div>
                          </TableCell>
                        </TableRow>
                        <hr />
                      </>
                    )) :

                    <TableRow className='' sx={{ marginBottom: 2 }}>
                      {/* <TableCell colSpan={3} className='text-center td'></TableCell>
                      <TableCell className='text-center td'>No result</TableCell>
                      <TableCell colSpan={3} className='text-center td'></TableCell> */}
                    </TableRow>
                  }
                </TableBody>
              </Table>

            </TableContainer>
            {/* Pagination */}
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                count={Math.ceil(configurations.filter(d=>d.type.toLowerCase()===type.toLowerCase()).length / rowsPerPage)}
                page={page}
                onChange={handlePageChange}
                className="custom-pagination"

              />
            </div>
          </div>
        </div>
      </div>
      {/* adding a new Package modal */}

      <Dialog className='p-0'
        open={openNew}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="container-fluid">
          <div className="row ">
            <div className="col-md-12 px-0 m-0">
              <form onSubmit={editedConfig ? updateConfigu : addNewConfigu}>
                <div className="card add_new_modal px-2">
                  <div className="card-header bg-white">
                    {editedConfig ? `Edit ${type?.trim()?.toLowerCase()==='transportation services for'?'Transportation Trip':type?.trim()?.toLowerCase()==='transports'?'Transportation Type':type.endsWith('ss')?type:type.endsWith('ies')?type.slice(0,-3)+'y':type.endsWith('s')?type.slice(0,-1):type}` : `Add new ${type?.trim()?.toLowerCase()==='transportation services for'?'Transportation Trip':type?.trim()?.toLowerCase()==='transports'?'Transportation Type':type.endsWith('ss')?type:type.endsWith('ies')?type.slice(0,-3)+'y':type.endsWith('s')?type.slice(0,-1):type}`}
                    
                  </div>
                  <div className="card-body pt-0">
                    <div className="row  py-2">
                     {editedConfig &&
                      <div className="col-md-12 mt-2 mb-2 justify-content-between d-flex">
                      <div className="d-flex left">
                        <h5>Activation</h5>
                      </div>
                      <div className="right my-auto d-flex">
                        <p className='me-2 my-auto'>{isActive ? "Active" : "Inactive"}</p>
                        <label className="switch my-auto">
                          <input type="checkbox" checked={isActive}
                            onChange={handleToggle} />
                          <span className="slider round"></span>

                        </label>

                      </div>
                    </div>
                     }
                      <div className={`data my-1  px-1 ${(type==='airlines'||type==='hotels'||type==='shirka')?'col-md-6':'col-md-12'}`}>
                        <label htmlFor="" >{type.endsWith('ss')?type:type.endsWith('ies')?type.slice(0,-3)+'y':type.endsWith('s')?type.slice(0,-1):type}</label>
                        <input type="text" value={title} placeholder="Name here" onChange={(e) => setTitle(e.target.value)} className='mt-1' id="" required />
                      </div>

                      {type==='shirka' &&
                        <div className='data my-1  px-1 col-md-6'>
                        <label htmlFor="" >Shirka Logo</label>
                        <input type="file" accept="image/*" placeholder="Name here" onChange={handleShirkaImage} className='mt-1' id="" />
                      </div>
                      }
                      

                      {type==='hotels' &&
                        <div className="data my-1 col-md-6 px-1">
                        <label htmlFor="" >Hotel Type</label>
                       <select value={hotel_type} onChange={(e)=>sethotel_type(e.target.value)} required>
                        <option value="">Select</option>
                        {configurations &&configurations.filter(d=>d.type.toLowerCase()==='hotel types'&&d.isActive).map((d,index)=>(
                          <option key={index} value={d.title}>{d.title}</option>
                        ))}
                       </select>
                      </div>
                      }
                      {type==='airlines'&&
                       <div className="data my-1 col-md-6 px-1">
                       <label htmlFor="" >{type.slice(0,-1)} Code:</label>
                       <input type="text" value={code} placeholder={`${type.endsWith('ss')?type:type.endsWith('ies')?type.slice(0,-3)+'y':type.endsWith('s')?type.slice(0,-1):type} code here (optional)`} onChange={(e) => setCode(e.target.value)} className='mt-1' id="" />
                     </div>
                      }
                     
                      {type &&type==='hotels'&&
                      <>
                       <div className="data my-1 col-md-6 px-1">
                        <label htmlFor="" >Hotel City</label>
                       
                        <select name="" id=""  value={location} onChange={(e) => setlocation(e.target.value)} required>
                          <option value="">Select</option>
                          <option value="makkah">MAKKAH</option>
                          <option value="madinah">MADINAH</option>
                        </select>
                      </div>
                      <div className="data my-1 col-md-6 px-1">
                        <label htmlFor="" >Distance (In Meters)</label>
                        <input type="text" value={distance} placeholder={`Distance in meters `} onChange={(e) => setdistance(e.target.value)} className='mt-1' required/>
                      </div>
                    
                        <h5 className='mt-2 mb-1'>Facilities</h5>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="d-flex flex-wrap">
                              {configurations &&
                                configurations
                                  .filter((d) => d.type.toLowerCase() === 'facilities' && d.isActive)
                                  .map((data, index) => (
                                    <Chip
                                      key={index}
                                      className="border"
                                      label={data.title}
                                      icon={!facilities.includes(data.title) ? <AddIcon sx={{ fontSize: 18 }} /> : undefined}
                                      onClick={() => handleToggleFacilities(data.title)}
                                      sx={{
                                        fontSize: 12,
                                        color: facilities.includes(data.title) ? 'white' : 'black',
                                        background: facilities.includes(data.title) ? '#08A5DC' : 'white',
                                      }}
                                      clickable
                                      onDelete={
                                        facilities.includes(data.title)
                                          ? () => handleToggleFacilities(data.title)
                                          : undefined
                                      }
                                    />
                                  ))}
                            </div>
                          </div>
                        </div>

                        <h5 className='mt-2 mb-1'>Images</h5>
                        <p>
                        Upload up to 5 images
                      </p>
                      <input accept='image/*' type="file" onChange={handleImage} />
                      <div className='my-2 '>
                        {images && images.map((image, index) => (
                          <div key={index} className='col-md-3 col-sm-6 images m-1' style={{ position: 'relative', display: 'inline-block' }}>
                            <img src={image} className='m-1 border rounded' alt={`Product thumbnail ${index + 1}`} style={{ maxWidth: '100%', maxHeight: '100%', cursor: 'pointer' }} onClick={() => handleRemoveImage(index)} />
                            <button className=' p-0 rounded' onClick={() => handleRemoveImage(index)} style={{ position: 'absolute', top: '3px', right: '2px', background: 'transparent', border: 'none', color: 'red', cursor: 'pointer',fontSize:12 }}><i className="fas fa-trash-alt"></i></button>
                          </div>
                        ))}
                      </div>
                      </>
                      }                      
                      <hr />
                      <div className="text-end mt-1 pb-0">
                        <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleCloseNew()} disabled={loading1}>Cancel</button>
                        <button className="btn save_btn mx-2 " type='submit' disabled={loading1}>{loading1 ? "Saving" : "Save"}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>



   <Dialog
  open={isImagesModal}
  onClose={handleCancelViewImages}
  maxWidth="xs" // Reduce the maximum width of the dialog
  fullWidth // Ensure it adjusts to the reduced width
  keepMounted
  aria-describedby="alert-dialog-slide-description"
  PaperProps={{
    style: {
      maxHeight: '450px', // Set a reduced height for the dialog
      width: '90%', // Ensure responsive width
      overflow: 'hidden', // Prevent overflow
    },
  }}
>
  <div className="container">
    <div className="row images_modal">
      <div className="col-md-12">
        <div
          id="carouselExample"
          className="carousel slide carousel-fade px-2 py-3"
          style={{ overflow: "hidden" }} // Prevent shifts dynamically
        >
          <div className="carousel-inner" style={{ overflow: "hidden" }}>
            {viewImages?.length > 0 &&
              viewImages.map((data, index) => (
                <div
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                  key={index}
                >
                  <img src={data} className="d-block w-100" alt="Images" />
                </div>
              ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="prev"
          >
            <i className="fa-solid fa-arrow-left-long my-auto pt-2"></i>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExample"
            data-bs-slide="next"
          >
            <i className="fa-solid fa-arrow-right-long my-auto pt-2"></i>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</Dialog>


    </div>
  )
}
